function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _path, _g;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgNewsManager = function SvgNewsManager(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none",
    viewBox: "0 0 168 144"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "a",
      width: 78,
      height: 134,
      x: 45,
      y: 5,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "luminance"
      },
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M122.965 5.93h-77.93V138.07h77.93z"
      }))
    }), _g || (_g = /*#__PURE__*/_jsxs("g", {
      mask: "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#006A00",
        d: "M74.348 53.31a1.148 1.148 0 1 0-2.272.341l1.632 10.918a1.149 1.149 0 1 0 2.271-.34z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00DB00",
        d: "M97.058 51.13 82.206 26.658c-.908-1.496-3.07-1.517-4.006-.039L61.109 55.155a2.84 2.84 0 0 0 .045 2.993 2.84 2.84 0 0 0 2.808 1.276l31.43-4.732c1.666-.25 2.54-2.12 1.666-3.563z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006A00",
        d: "M96.973 54.357c2.712-1.651.965-9.492-3.903-17.513S82.058 23.658 79.346 25.309s-.965 9.492 3.903 17.513S94.26 56.007 96.973 54.357"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#004800",
        stroke: "#00460C",
        strokeMiterlimit: 10,
        strokeWidth: 0.81,
        d: "M90.005 40.643c.525-.32.446-1.412-.178-2.44S88.27 36.6 87.746 36.92c-.526.32-.446 1.413.178 2.441s1.555 1.602 2.08 1.282Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006A00",
        d: "M105.037 53.37h-.017a.91.91 0 0 1-.895-.93c0-.09.073-9.098-5.945-19.128-5.895-9.826-13.03-12.32-13.102-12.344a.914.914 0 0 1 .576-1.735c.316.105 7.821 2.687 14.092 13.137 6.302 10.504 6.212 19.715 6.205 20.102a.91.91 0 0 1-.912.897z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006716",
        d: "M113.496 53.215h-.017a.91.91 0 0 1-.895-.931c.001-.109.092-11.097-7.246-23.33-7.201-12.002-15.927-15.043-16.014-15.073a.916.916 0 0 1-.577-1.156.91.91 0 0 1 1.151-.58c.382.128 9.428 3.24 17.004 15.868 7.623 12.706 7.515 23.835 7.507 24.303a.913.913 0 0 1-.913.897z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#006A00",
        d: "M122.052 52.624h-.017a.913.913 0 0 1-.896-.931c.002-.125.11-12.707-8.294-26.712-8.282-13.804-18.258-17.236-18.357-17.27a.913.913 0 0 1 .573-1.735c.11.036 2.751.928 6.466 3.615 3.394 2.454 8.385 6.953 12.882 14.45 4.536 7.56 6.619 14.665 7.569 19.294 1.033 5.038.988 8.257.985 8.392a.91.91 0 0 1-.912.897z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FA3B48",
        d: "m49.116 88.716.348 1.58a1.74 1.74 0 0 0 2.078 1.328h.001a1.745 1.745 0 0 0 1.325-2.081l-.348-1.58a1.74 1.74 0 0 0-2.078-1.328h-.001a1.745 1.745 0 0 0-1.325 2.08"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C5C5C5",
        d: "M50.36 88.747a4.076 4.076 0 0 1-4.027-3.507l-1.01-7.133a4.08 4.08 0 0 1 .586-2.744l5.468-8.703a4.067 4.067 0 0 1 5.615-1.28 4.08 4.08 0 0 1 1.278 5.623l-4.674 7.44.8 5.654a4.076 4.076 0 0 1-4.037 4.65"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M47.982 138.071q-.241 0-.487-.041a2.947 2.947 0 0 1-2.42-3.392l7.88-47.35c.574-3.45 3.525-6.043 7.016-6.164a7.32 7.32 0 0 1 5.212 1.916 7.34 7.34 0 0 1 2.397 4.995l3.058 42.519a2.947 2.947 0 0 1-2.724 3.152 2.946 2.946 0 0 1-3.147-2.728l-3.058-42.532q0-.016-.003-.032a1.48 1.48 0 0 0-1.48-1.397h-.053a1.49 1.49 0 0 0-1.412 1.242l-7.88 47.35a2.945 2.945 0 0 1-2.899 2.463z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M68.979 133.374h1.977a.37.37 0 0 0 .368-.368v-.002a.37.37 0 0 0-.368-.368h-1.977a.37.37 0 0 0-.368.368v.002c0 .203.165.368.368.368M49.42 137.854h1.976a.37.37 0 0 0 .368-.368v-.002a.37.37 0 0 0-.368-.368H49.42a.37.37 0 0 0-.368.368v.002c0 .203.165.368.368.368"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FA3B48",
        d: "M59.337 59.369a1.64 1.64 0 0 0-2.17-.803 1.64 1.64 0 0 0 1.369 2.977q.253-.118.445-.304a1.64 1.64 0 0 0 .356-1.87M74.504 61.294l-1.196 1.088a1.747 1.747 0 0 0-.118 2.465l.001.001a1.74 1.74 0 0 0 2.461.118l1.196-1.088a1.747 1.747 0 0 0 .118-2.465v-.001a1.74 1.74 0 0 0-2.462-.118"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C5C5C5",
        d: "M71.225 75.517a4.3 4.3 0 0 1-1.495-.273l-11.318-4.269a4.25 4.25 0 0 1-2.476-5.477 4.24 4.24 0 0 1 5.468-2.48l7.863 2.965.612-1.125a4.24 4.24 0 0 1 5.759-1.695 4.254 4.254 0 0 1 1.693 5.767l-2.38 4.37a4.24 4.24 0 0 1-3.727 2.217z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C6C6C6",
        d: "M62.44 83.904q-.765.144-1.53.296c-2.951.586-5.93-1.362-7.158-5.175a292 292 0 0 0-2.753-9.5c-.577-2.382 1.383-5.64 4.883-6.365q.892-.186 1.79-.358c3.515-.685 7 1.507 7.602 4.687q.965 4.865 1.76 9.742c.496 3.19-1.634 6.12-4.594 6.675z"
      })]
    }))]
  }));
};
export default SvgNewsManager;